import { GuestsObject } from "components/HeroSearchForm/type";
import NcInputNumber from "components/NcInputNumber/NcInputNumber";
import React from "react";

export interface GuestsInputProps {
  defaultValue?: GuestsObject;
  onChange?: (data: GuestsObject) => void;
  className?: string;
}

const GuestsInput: React.FC<GuestsInputProps> = ({ className = "" }) => {
  return (
    <div className={`flex flex-col relative p-5 ${className}`}>
      <span className="mb-5 block font-semibold text-xl sm:text-2xl">
        {`Quem está indo?`}
      </span>
      <NcInputNumber className="w-full mt-6" max={10} />
    </div>
  );
};

export default GuestsInput;
